module.exports = __webpack_public_path__ + "static/img/086_TO8_1740.e75bde8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/086_TO8_1740.jpg
// module id = tPeB
// module chunks = 0